var scope_0 = require('/vercel/path0/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/08232921b61729c007a8c0a423206b25.js').default;export default
        Object.assign({}, scope_0 )
    